import { get, post, put, _delete } from './Tools';

const getAll = async () => {
  try {
    const response = await get(`${process.env.REACT_APP_SERVER}tipo_efectivo`);
    return response;
  } catch (error) {
    console.error('Error al obtener denominaciones:', error);
    return { ok: false, message: error.message };
  }
};

const create = async (payload) => {
  try {
    const response = await post(`${process.env.REACT_APP_SERVER}tipo_efectivo`, payload);
    return response;
  } catch (error) {
    console.error('Error al crear la denominación:', error);
    return { ok: false, message: error.message };
  }
};

const update = async (payload) => {
  try {
    const response = await put(`${process.env.REACT_APP_SERVER}tipo_efectivo`, payload);
    return response;
  } catch (error) {
    console.error('Error al actualizar la denominación:', error);
    return { ok: false, message: error.message };
  }
};

const drop = async (id) => {
  try {
    const response = await _delete(`${process.env.REACT_APP_SERVER}tipo_efectivo/${id}`);
    return response;
  } catch (error) {
    console.error('Error al eliminar la denominación:', error);
    return { ok: false, message: error.message };
  }
};

export { getAll, create, update, drop };